// frontend/src/samkalp-faculty/mentoring/PublishSlotsForm.js
//
// Faculty publishes fixed 30-minute mentoring slots directly: pick a date,
// add one or more start times, submit them all in one call. No open
// availability windows for students to slice up — every slot is exactly
// 30 minutes, matching mentoring_service.py's SLOT_DURATION_MINUTES.
import React, { useState } from 'react';
import { Form, Button, Alert, Spinner, Row, Col, Badge } from 'react-bootstrap';
import { publishMentoringSlots } from '../../api/mentoringApi';

const PublishSlotsForm = ({ slug, onPublished }) => {
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [times, setTimes] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const addTime = () => {
        if (!time) return;
        if (!times.includes(time)) setTimes(prev => [...prev, time].sort());
        setTime('');
    };

    const removeTime = (t) => setTimes(prev => prev.filter(x => x !== t));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); setSuccess('');
        if (!date || times.length === 0) {
            setError('Pick a date and add at least one start time.');
            return;
        }
        setLoading(true);
        try {
            const slotStarts = times.map(t => `${date}T${t}:00+05:30`);
            await publishMentoringSlots(slug, slotStarts);
            setSuccess(`Published ${times.length} slot(s) for ${date}.`);
            setTimes([]);
            onPublished && onPublished();
        } catch (err) {
            setError(err.response?.data?.detail || 'Could not publish slots. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form onSubmit={handleSubmit} className="publish-slots-form">
            {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}
            {success && <Alert variant="success" className="py-2 small">{success}</Alert>}

            <Row>
                <Col md={4}>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold small text-uppercase text-muted">Date (IST)</Form.Label>
                        <Form.Control type="date" value={date} onChange={e => setDate(e.target.value)} required />
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold small text-uppercase text-muted">Start Time (30-min slots)</Form.Label>
                        <Form.Control type="time" step={1800} value={time} onChange={e => setTime(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col md={4} className="d-flex align-items-end mb-3">
                    <Button variant="outline-secondary" onClick={addTime} disabled={!time}>+ Add Time</Button>
                </Col>
            </Row>

            {times.length > 0 && (
                <div className="mb-3 d-flex flex-wrap gap-2">
                    {times.map(t => (
                        <Badge key={t} bg="light" text="dark" className="border p-2">
                            {t} <span style={{ cursor: 'pointer', marginLeft: 6 }} onClick={() => removeTime(t)}>✕</span>
                        </Badge>
                    ))}
                </div>
            )}

            <Button type="submit" disabled={loading || times.length === 0}>
                {loading ? <Spinner animation="border" size="sm" /> : `Publish ${times.length || ''} Slot(s)`}
            </Button>
        </Form>
    );
};

export default PublishSlotsForm;
